import React, { useEffect, useState } from 'react';
import PackageCard from '../Components/PackageCard';
import {ArrowDownward } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { Typography, Paper, Box, Button, Tooltip } from '@mui/material';
import {  useTheme } from '@mui/system';
import CreatePackageModal from '../Components/CreatePackageModal';
import { fetchComponents } from '../utils/api';
import {CircularProgress} from '@mui/material';
import PendingReviewTable from '../Components/PendingReviewTable';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useGlobal } from '../Context/globalContext';
import Loader from '../Components/Loader';


const Dashboard = () => {
  const { userData, bucketURLS={} } = useGlobal();
  const [searchParam, setSearchParam] = useState('');
  const [allPackagesData, setAllPackagesData] = useState([]);
  const [downloadUrl, setDownloadUrl] = useState('');
  const [open, setOpen] = React.useState(false);
  const [totalPackagesToShow, setTotalPackagesToShow] = useState(100);
  const [showLoader, setShowLoader] = useState(false);
  const [currentCategory, setCurrentCategory] = useState('')
  const [packagesDataForCategory, setPackagesDataForCategory] = useState([])




  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();



  useEffect(() => {
    if(bucketURLS.portal){
      setDownloadUrl(bucketURLS.portal)
    }
  }, [bucketURLS])



  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const searchParam = queryParams.get("search");
    setSearchParam(searchParam)
  }, [location.search])


  useEffect(() => {
    // Determine selected category
    const selectedCategory =
      location?.state?.selectedCategory ||
      location?.pathname?.split('/')?.[1] ||
      'all-packages';

    setCurrentCategory(selectedCategory);

    const specialCategories = ['my-packages', 'pending-review', 'all-packages'];

    const loadData = () => {
      setShowLoader(true);
      fetchComponents(selectedCategory)
        .then(data => {
         if(specialCategories.includes(selectedCategory)){
           setAllPackagesData(data || []);
         }else{
          setPackagesDataForCategory(data || [])
         }
          setOpen(false);
        })
        .catch(err => {
          console.error('Error fetching components:', err);
          setAllPackagesData([]);
          setPackagesDataForCategory([])
        })
        .finally(() => setShowLoader(false));
    };

    // If special category → fetch directly
    if (specialCategories.includes(selectedCategory)) {
      loadData();
      return;
    }else{
      // If regular category but we already have data → filter it
      if (!allPackagesData?.length) {
        loadData();
      } 

    }



  }, [location?.state?.selectedCategory]);



  const selectedCategory = location && location.state && location.state.selectedCategory;


  let categoryPackagesData = allPackagesData.length && allPackagesData.filter(item => {
    return !selectedCategory || selectedCategory === 'All' || selectedCategory === 'my-packages' || selectedCategory === 'pending-review' ? item : item.categoryName === selectedCategory
  }) || packagesDataForCategory;

  if (searchParam) {
    categoryPackagesData = categoryPackagesData.filter(item => {
      return item.templateName.toLowerCase().includes(searchParam.toLowerCase())
    })
  }

  const hideViewAll = selectedCategory && selectedCategory === 'my-packages' ? true : false;


  const packagesWrapperStyle = {
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: 'repeat(auto-fill, minmax(210px, 1fr))',
    padding: '0',
    boxShadow: 'none',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)', // Two cards per row below "md" (900px)
      justifyContent: 'center',
      alignItems: 'center',
    },

  };

  const selectedCategoryStyles = {
    padding: "10px 20px"
  }

  const cardsWrapperStyles = {
    padding: "0 20px",
    [theme.breakpoints.down('md')]: {
      padding: 0
    },
  }




  const navigatetoPackageInfo = async (item) => {
    navigate(`/package?componentName=${item?.componentName}&templateName=${item.templateName}`, {
      state: {
        hd_id: userData?.hd_id,
        publishDate: item?.publishDate,
        componentName: item?.componentName,
        templateName: item?.templateName,
        from:'dashboard'

      }
    });
  };

  
  const navigateApprovalPage = async (item) => {
    navigate(`/approval?componentName=${item.componentName}`, {
      state: {
        componentName: item?.componentName,
        templateName: item?.templateName,
        downloadUrl:downloadUrl,
        item:item

      }
    });
  };

  const handleShowMore = (() => {
    if (totalPackagesToShow < categoryPackagesData.length) {
      setTotalPackagesToShow(totalPackagesToShow + 15)
    }
  })


  return (
    <div>
      {
        selectedCategory === 'my-packages' && userData?.hd_id ?
          <Box sx={{ textAlign: 'right' }}>
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                setOpen(!open);
              }}
              sx={{
                background: "#f05f40"
              }}
            >
              Create Package
            </Button>
          </Box>
          : null
      }
      {
        open && <CreatePackageModal
          userData={userData}
          open={open} onClose={() => {
            setOpen(false)

          }} />
      }

      <Typography sx={selectedCategoryStyles}
        style={{ fontWeight: 600, fontSize: '20px', display: 'flex', alignItems: 'center' }}
      >
        {selectedCategory === 'All' || !selectedCategory
          ? `All Categories`
          : selectedCategory === 'my-packages'
            ? 'My Packages'
            : selectedCategory === 'pending-review'
              ? 'Pending Review'
              : selectedCategory
        }

        {selectedCategory === 'pending-review' && (
          <Tooltip
            arrow
            placement="right"
            title={
              <Box sx={{ p: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                  <Box sx={{ width: 10, height: 10, borderRadius: '50%', background: 'yellow', mr: 1 }} />
                  <Typography variant="body2">Pending — submitted for review (not on dev yet)</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                  <Box sx={{ width: 10, height: 10, borderRadius: '50%', background: 'blue', mr: 1 }} />
                  <Typography variant="body2">Under Review — on dev but not on prod</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box sx={{ width: 10, height: 10, borderRadius: '50%', background: 'green', mr: 1 }} />
                  <Typography variant="body2">Tested — tested on dev and ready for prod</Typography>
                </Box>
              </Box>
            }
          >
            <InfoOutlinedIcon sx={{ ml: 1, cursor: 'pointer', fontSize: 20 }} />
          </Tooltip>
        )}
      </Typography>
      <Box sx={cardsWrapperStyles}>
        <Paper sx={{
          minHeight: "70vh",
          ...(currentCategory !== "pending-review" && !showLoader ? packagesWrapperStyle : {})
        }}>
          {categoryPackagesData && (
            <>
              {showLoader  ? <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', width:'100%'}}>
                <Loader />
              </Box>   : !categoryPackagesData.length  ? (
                <Typography style={{ margin: '10px 0' }}>No Package Found!</Typography>
              ) : (
                currentCategory !== 'pending-review' ? categoryPackagesData
                  .slice(0, totalPackagesToShow)
                  .map((item, index) => (
                    <PackageCard
                      downloadUrl={downloadUrl}
                      name={item.templateName}
                      categoryName={item.categoryName}
                      info={item?.info}
                      onClick={() => {
                        navigatetoPackageInfo(item);
                      }}
                    />
                  )) :  <PendingReviewTable
                          data={categoryPackagesData}
                          userData={userData}
                          onDetailsClick={navigateApprovalPage}
                        />
              )}
            </>
          )}

        </Paper>
        {
          (!hideViewAll && categoryPackagesData && categoryPackagesData.length > totalPackagesToShow) ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}>
                <Button variant="outlined" sx={{ textTransform: 'none' }} endIcon={<ArrowDownward />} onClick={() => {
                  handleShowMore()
                }}>
                  See more
                </Button>
              </div>
            </div>
          ) : null
        }
      </Box>
    </div>
  );
};

export default Dashboard;
